import { render, staticRenderFns } from "./general-actions.vue?vue&type=template&id=306cd91e&scoped=true"
import script from "./general-actions.vue?vue&type=script&lang=js"
export * from "./general-actions.vue?vue&type=script&lang=js"
import style0 from "./general-actions.vue?vue&type=style&index=0&id=306cd91e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306cd91e",
  null
  
)

export default component.exports